import React, { Component } from "react";
import moment from 'moment';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  FormFeedback,
  Label,
  Input
} from "reactstrap";
import Joi from "joi-browser";
import {AgentService } from "../../services";
import httpClient from "../../http-client/client";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import DatePicker from "react-datepicker";

class UpdateRates extends Component {
  constructor(props) {
    super(props);
 
    
  }

  state = {
  cityId:'',
  provinceid:'',
  provinceList:[],
  cityList:[],
  productList:[],
  productTypeList:[],
  date: new Date(),
  product_id:'',
  product_type_id:'',
  start_rate:'',
  end_rate:'',
  avg_rate:'',
  errors: {},
  rate_id:''
  };

  //schema
  componentWillMount(){

    this.getProvince();

    this.getProducts(); 
    this.getProductRates();
  }
  componentDidMount() {

this.getProvince();

   this.getProducts(); 
   this.getProductRates();
  }
  handleSalePurchaseDate = date => {
   this.setState({date:date})
  };
  getProductRates = async () => {
    try {
      let mainUrl=window.location.href.split('?')
      let { data } =  await httpClient.get(`/products/product-rates/${mainUrl[1]}`);
    console.log(data)
  
  this.setState({product_id:data.response.product_id,product_type_id:data.response.product_type_id,provinceid:data.response.state_id,cityId:data.response.city_id,start_rate:data.response.start_rate,end_rate:data.response.end_rate,date:new Date(data.response.rate_date)})
  this.getProductTypes(this.state.product_id)
    this.getCity(this.state.provinceid)
    } catch (error) {}
  };
getProvince = async () => {
  try {
    let { data } =  await httpClient.get(`/states/`);
  
 
    this.setState({ provinceList: data.response});
  
  } catch (error) {}
};
getCity = async (id) => {
  try {
    let { data } =  await httpClient.get(`/cities/${id}`);
  
 
    this.setState({ cityList: data.response,provinceid:id});
  
  } catch (error) {}
};
getProducts = async () => {
  try {
    let { data } =  await httpClient.get(`/products`);
  
 
    this.setState({ productList: data.response});
  
  } catch (error) {}
};
getProductTypes = async (id) => {
  try {
    let { data } =  await httpClient.get(`/products/product-types/${id}`);
  
    this.setState({ productTypeList: data.response,product_id:id});
  
  } catch (error) {}
};
handleSubmit = async (id) => {
  try {
    
    let mainUrl=window.location.href.split('?')
  let data={
    "city_id":this.state.cityId,
    "rate_date":   moment(this.state.date).format('YYYY-MM-DD'),
    "product_id":this.state.product_id,
    "product_type_id":this.state.product_type_id,
    "start_rate":this.state.start_rate,
    "end_rate":this.state.end_rate,
    "average_rate":(parseInt(this.state.start_rate)+parseInt(this.state.end_rate))/2,
    "rate_id":mainUrl[1], 
  }
 
  let { status } =  await httpClient.put("/products/product-rates",data);
 
  if(status==200){
    this.props.history.push("/dashboard/Rates");
  }
  
  
  } catch (error) {}
};
handleBack = async (id) => {
  try {
    
    this.props.history.push("/dashboard/Rates");
  } catch (error) {}
};
counter=()=>{
let a=(this.state.start_rate+this.state.end_rate)/2
this.setState({avg_rate:a})
}
  render() {
let {  errors ,productList, provinceList,cityList,productTypeList}=this.state;

    const provinceList1 = provinceList.map(p => (
      <option key={p['state_id']} value={p['state_id']}>
        {p['state_name']}
      </option>
    ));

    const cityList1 = cityList.map(c => (
      <option key={c['city_id']} value={c['city_id']}>
        {c['city_name']}
      </option>
    ));

    const productList1 = productList.map(p => (
      <option key={p["product_id"]} value={p["product_id"]}>
        {p["product_name"]}
      </option>
    ));
    const productTypeList1 = productTypeList.map(p => (
      <option key={p["product_type_id"]} value={p["product_type_id"]}>
        {p["product_type_name"]}
      </option>
    ));
    return (
   
     <div>

     
          <Form className='row'>


       <div className="row col-md-12">

      
                <FormGroup className='col-sm-12 col-md-6'>
                  <Label for='city'>شہر</Label>
                  <Input
                    type='select'
                    value={this.state.cityId}
                    name='cityId'
                    id='city'
                    invalid={Boolean(errors['cityId'])}
                    onChange={(e)=>{
                      this.setState({cityId:e.target.value})
                    }}
                  >
                    <option value=''>Select City</option>
                    {cityList1}
                  </Input>
                  {errors['cityId'] && (
                    <FormFeedback>{errors['cityId']}</FormFeedback>
                  )}
                </FormGroup>

                <FormGroup className='col-sm-12 col-md-6'>
                  <Label for='province'>صوبہ</Label>
                  <Input
                  value={this.state.provinceid}
                    type='select'
                    name='provinceid'
                    id='provinceid'
                    invalid={Boolean(errors['province'])}
                    onChange={e => {
                     this.getCity(e.target.value);
                    }}
                  >
                    <option value=''>Select Province</option>
                    {provinceList1}
                  </Input>
                </FormGroup>
                </div>
                <div className="row col-md-12">
                <FormGroup className='col-sm-12 col-md-6'>
                <Label for="partyName">قسم جنس</Label>
                  <Input
                    type='select'
                    value={this.state.product_type_id}
                    name='product_type_id'
                    id='product_type_id'
                    invalid={Boolean(errors['cityId'])}
                   onChange={(e)=>{this.setState({product_type_id:e.target.value})}}
                  >
                    <option value=''>Select Product Type</option>
                    {productTypeList1}
                  </Input>
                  {errors['cityId'] && (
                    <FormFeedback>{errors['cityId']}</FormFeedback>
                  )}
                </FormGroup>

                <FormGroup className='col-sm-12 col-md-6'>
                <Label for="partyName"> جنس</Label>
                  <Input
                    type='select'
                    name='product_id'
                    value={this.state.product_id}
                    id='product_id'
                    invalid={Boolean(errors['province'])}
                    onChange={e => {
                    this.getProductTypes(e.target.value);
                    }}
                  >
                    <option value=''>Select Product</option>
                    {productList1}
                  </Input>
                </FormGroup>
                </div>
                <div className="row col-md-12">
                <FormGroup className="col-sm-12">
                  <Label for="partyName">تاریخ</Label>
                  <DatePicker
          style={{ dipslay: "block" }}
          dateFormat="yyyy/MM/dd"
          selected={this.state.date}
          onChange={this.handleSalePurchaseDate}
        />
                  {errors["partyName"] && (
                    <FormFeedback>{errors["partyName"]}</FormFeedback>
                  )}
                </FormGroup>
                </div>
           <div className="row col-md-12">
           <FormGroup className="col-sm-12 col-md-6">
                  <Label for="partyName"> کم سے کم ریٹ </Label>
                  <Input
                    type="text"
                    value={this.state.start_rate}
                    name="start_rate"
                    id="start_rate"
                    placeholder="start rate"
                    invalid={Boolean(errors["partyName"])}
                    onChange={(e)=>{this.setState({start_rate:e.target.value})}}
                  />
                  {errors["partyName"] && (
                    <FormFeedback>{errors["partyName"]}</FormFeedback>
                  )}
                </FormGroup>
                <FormGroup className="col-sm-12 col-md-6">
                  <Label for="partyName">زیادہ سے زیادہ ریٹ</Label>
                  <Input
                    type="text"
                    value={this.state.end_rate}
                    name="end_rate"
                    id="end_rate"
                    placeholder="end rate"
                    invalid={Boolean(errors["partyName"])}
                    onChange={(e)=>{this.setState({end_rate:e.target.value})}}
                  />
                  {errors["partyName"] && (
                    <FormFeedback>{errors["partyName"]}</FormFeedback>
                  )}
                </FormGroup>
           </div>
             
           <div className="row col-md-12">
                <FormGroup className="col-sm-12 col-md-6">
                  <Label for="partyName">اوسط ریٹ</Label>
                  {this.state.start_rate!=""&&this.state.end_rate!=""&&
                  <Input
                    type="text"
                     value={(parseInt(this.state.start_rate)+parseInt(this.state.end_rate))/2}
                    name="avg_rate"
                    id="avg_rate"
                    placeholder="avg rate"
                    invalid={Boolean(errors["partyName"])}
                    disabled={true}
                   
                  />
  }
                  {errors["partyName"] && (
                    <FormFeedback>{errors["partyName"]}</FormFeedback>
                  )}
                </FormGroup>
                </div>

                <div className='col-sm-12 col-md-12 text-left'>
                  <Button
                    className='small '
                    color='success'
                    onClick={this.handleSubmit}
                  >
                    محفوظ کریں
                  </Button>
                  <Button
                    className='small '
                    color='danger'
                    style={{marginLeft:"20px"}}
                    onClick={this.handleBack}
                  >
                   منسوخ کریں
                  </Button>
                </div>
              </Form>
    

        {/* toast notifiction */}
        <ToastContainer />
      </div>
    );
  }
}

export default UpdateRates;
